export default __webpack_public_path__ + "static/media/dynatrace.ab0a725e6c86804711c8bcf5f4541cf8.svg";